import {
  WSButton,
  WSElement,
  WSElementProps,
  WSFlexBox,
  WSPanel,
  WSSectionToolbar
} from "@wingspanhq/fe-component-library";
import { IPayerResponse } from "@wingspanhq/payments/dist/interfaces";
import { InfoItem } from "../../components/ClientInfoPanel/InfoItem";
import { copyText } from "../../../../utils/copyText";

import styles from "./styles.module.scss";

export interface IWireTransferSectionProps extends WSElementProps {
  client: IPayerResponse;
}

export const WireTransferSection: React.FC<IWireTransferSectionProps> = ({
  client,
  ...elementProps
}) => {
  const { bankTransferProcessingAccount } = client;

  return bankTransferProcessingAccount &&
    bankTransferProcessingAccount.routingNumber ? (
    <WSElement {...elementProps}>
      <WSSectionToolbar
        title="Wire transfers"
        tooltip={{
          title: "Wire transfers",
          text: "This is the secure payment gateway setup for this client that routes money to your direct deposit without you having to provide your own banking info."
        }}
      />

      <WSPanel className={styles.panel}>
        <WSFlexBox.CenterY mb="XL" justify="space-between">
          <InfoItem
            label="Bank name"
            value={bankTransferProcessingAccount?.bankName ?? ""}
          />
          <WSButton.Link
            onClick={() => {
              copyText(
                bankTransferProcessingAccount?.bankName ?? "",
                "Bank name copied to clipboard"
              );
            }}
          >
            Copy
          </WSButton.Link>
        </WSFlexBox.CenterY>

        <WSFlexBox.CenterY mb="XL" justify="space-between">
          <InfoItem
            label="Routing number"
            value={bankTransferProcessingAccount?.routingNumber ?? ""}
          />
          <WSButton.Link
            onClick={() => {
              copyText(
                bankTransferProcessingAccount?.routingNumber ?? "",
                "Routing number copied to clipboard"
              );
            }}
          >
            Copy
          </WSButton.Link>
        </WSFlexBox.CenterY>

        <WSFlexBox.CenterY mb="XL" justify="space-between">
          <InfoItem
            label="Account number"
            value={bankTransferProcessingAccount?.accountNumber ?? ""}
          />
          <WSButton.Link
            onClick={() => {
              copyText(
                bankTransferProcessingAccount?.accountNumber ?? "",
                "Account number copied to clipboard"
              );
            }}
          >
            Copy
          </WSButton.Link>
        </WSFlexBox.CenterY>
      </WSPanel>
    </WSElement>
  ) : null;
};
